import React from 'react'

import { FamilyAgeAllowance } from 'core/application/adminDashboard/benefitDetails/design/productClass/getProductClassDesignSummary'

import { Icon } from 'common/components'

const firstLastAgeRender = (age: number, familyAgeAllowances: FamilyAgeAllowance[], index: number) => {
  if (index === 0) {
    return `${age} & younger`
  }
  if (age === familyAgeAllowances[familyAgeAllowances.length - 1].age) {
    return `${age} & older`
  }
  return age
}

export const differentAllowanceColumns = (familyAgeAllowances: FamilyAgeAllowance[]) => [
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
    render: (age: number, record, index: number) => firstLastAgeRender(age, familyAgeAllowances, index),
  },
  {
    title: 'Single',
    dataIndex: 'singleAmount',
    key: 'single',
    render: (number: number) => `$${number}`,
  },
  {
    title: 'Single + dependents',
    dataIndex: 'singleWithDependentsAmount',
    key: 'singleWithDependents',
    render: (number: number) => `$${number}`,
  },
  {
    title: 'Married',
    dataIndex: 'marriedAmount',
    key: 'married',
    render: (number: number) => `$${number}`,
  },
  {
    title: 'Married + dependents',
    dataIndex: 'marriedWithDependentsAmount',
    key: 'marriedWithDependents',
    render: (number: number) => `$${number}`,
  },
]
export const differentAllowanceColumnsV2 = (familyAgeAllowances: FamilyAgeAllowance[]) => [
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
    render: (age: number, record, index: number) => firstLastAgeRender(age, familyAgeAllowances, index),
  },
  {
    title: (
      <div className="flex flex__align_center">
        <Icon className="fal fa-user mr-4" />
        Single
      </div>
    ),
    dataIndex: 'singleAmount',
    key: 'single',
    render: (number: number) => `$${number}`,
  },
  {
    title: (
      <div className="flex flex__align_center">
        <Icon className="fal fa-user-friends mr-4" />
        Single + dependents
      </div>
    ),
    dataIndex: 'singleWithDependentsAmount',
    key: 'singleWithDependents',
    render: (number: number) => `$${number}`,
  },
  {
    title: (
      <div className="flex flex__align_center">
        <Icon className="fal fa-user-friends mr-4" />
        Married
      </div>
    ),
    dataIndex: 'marriedAmount',
    key: 'married',
    render: (number: number) => `$${number}`,
  },
  {
    title: (
      <div className="flex flex__align_center">
        <Icon className="fal fa-users mr-4" />
        Married + dependents
      </div>
    ),
    dataIndex: 'marriedWithDependentsAmount',
    key: 'marriedWithDependents',
    render: (number: number) => `$${number}`,
  },
]
export const sameAllowanceColumns = (familyAgeAllowances: FamilyAgeAllowance[]) => [
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
    render: (age: number, record, index: number) => firstLastAgeRender(age, familyAgeAllowances, index),
  },
  {
    title: 'Allowance',
    dataIndex: 'singleAmount',
    key: 'single',
    render: (number: number) => `$${number}`,
  },
]
